import { FaEdit, FaHome } from "react-icons/fa";
import { TbArrowsSort } from "react-icons/tb";
import DNDList from "../../components/DndBanner";
import { useNavigate } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { listProductLibBanners } from "../../graphql/queries";
import {
  deleteProductLibBanner,
  updateProductLibBanner,
} from "../../graphql/mutations";
import { useState, useEffect } from "react";
import {
  ProductLibBanner,
  UpdateProductLibBannerInput,
  DeleteProductLibBannerInput,
} from "../../API";
import { bannerStatus, bannerStatusCondition } from "../../constants/enum";
import ModalConfirm from "../../components/ModalConfirmNew";
import { FaTimesCircle } from "react-icons/fa";

function Banners() {
  const navigate = useNavigate();
  const [banners, setBanners] = useState<ProductLibBanner[]>([]);
  const [currentStatus, setCurrentStatus] = useState(bannerStatus.PUBLISHED);
  const [isDragging, setIsDragging] = useState(false);

  const [showConfirmRemove, setShowConfirmRemove] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [removeId, setRemoveId] = useState("");

  const fetchBannersData = async () => {
    const banner: any = await API.graphql(
      graphqlOperation(listProductLibBanners)
    );
    return banner.data.listProductLibBanners.items.sort(
      (a: ProductLibBanner, b: ProductLibBanner) => a.order - b.order
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      const banners = await fetchBannersData();
      const bannersFiltered = banners.filter(
        (banner: ProductLibBanner) => banner.status === currentStatus
      );
      setBanners(bannersFiltered);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const banners = await fetchBannersData();
      const bannersFiltered = banners.filter(
        (banner: ProductLibBanner) => banner.status === currentStatus
      );
      setBanners(bannersFiltered);
    };
    fetchData();
  }, [currentStatus]);

  useEffect(() => {
    if (removeId) {
      setShowConfirmRemove(true);
    }
  }, [removeId]);

  useEffect(() => {
    if (!showConfirmRemove) {
      setRemoveId("");
    }
  }, [showConfirmRemove]);

  const deleteBanner = async (id: string) => {
    try {
      await API.graphql(
        graphqlOperation(deleteProductLibBanner, {
          input: { id } as DeleteProductLibBannerInput,
        })
      );
      setBanners((prevBanners) =>
        prevBanners.filter((banner) => banner.id !== id)
      );
    } catch (error) {
      console.error("Error deleting banner:", error);
    }
    setRemoveId("");
    setIsLoading(false);
    setShowConfirmRemove(false);
  };

  const updateBannerOrder = async (bannersUpdate: ProductLibBanner[]) => {
    try {
      setBanners(bannersUpdate);
      let count = 0;
      for (const order of bannersUpdate) {
        count++;
        await API.graphql(
          graphqlOperation(updateProductLibBanner, {
            input: {
              id: order.id,
              order: count,
            } as UpdateProductLibBannerInput,
          })
        );
      }
    } catch (error) {
      console.error("Error updating banner order:", error);
    }
  };

  const btnClassActive = "bg-sky-700 text-white";
  return (
    <div className="Banners">
      <div className="flex items-center gap-3 font-bold p-7">
        <FaHome
          className="cursor-pointer"
          onClick={() => {
            navigate(`/`);
          }}
        />
        {bannerStatusCondition[currentStatus].text}
      </div>
      <div className="flex justify-between p-5">
        <div>
          <button
            className={`border rounded-full px-3 py-2 m-1 disabled:opacity-30 ${
              currentStatus === bannerStatus.PUBLISHED ? btnClassActive : ""
            }`}
            disabled={isDragging}
            onClick={() => setCurrentStatus(bannerStatus.PUBLISHED)}
          >
            Published
          </button>
          <button
            className={`border rounded-full px-3 py-2 m-1 disabled:opacity-30 ${
              currentStatus === bannerStatus.DRAFT ? btnClassActive : ""
            }`}
            disabled={isDragging}
            onClick={() => setCurrentStatus(bannerStatus.DRAFT)}
          >
            Draft
          </button>
          <button
            className={`border rounded-full px-3 py-2 m-1 disabled:opacity-30 ${
              currentStatus === bannerStatus.PENDING_PUBLISH
                ? btnClassActive
                : ""
            }`}
            disabled={isDragging}
            onClick={() => setCurrentStatus(bannerStatus.PENDING_PUBLISH)}
          >
            Pending Publish
          </button>
          <button
            className={`border rounded-full px-3 py-2 m-1 disabled:opacity-30 ${
              currentStatus === bannerStatus.HOLD ? btnClassActive : ""
            }`}
            disabled={isDragging}
            onClick={() => setCurrentStatus(bannerStatus.HOLD)}
          >
            Hold
          </button>
          <button
            className={`border rounded-full px-3 py-2 m-1 disabled:opacity-30 ${
              currentStatus === bannerStatus.END_OF_PROMOTION
                ? btnClassActive
                : ""
            }`}
            disabled={isDragging}
            onClick={() => setCurrentStatus(bannerStatus.END_OF_PROMOTION)}
          >
            End Of Promotion
          </button>
        </div>
        <div>
          <button
            className={`border rounded-lg px-3 py-2 m-1 disabled:opacity-30 ${
              isDragging
                ? "bg-green-700 text-white"
                : "text-sky-700 border-sky-700"
            }`}
            disabled={
              banners.length === 0 || currentStatus !== bannerStatus.PUBLISHED
            }
            onClick={() => setIsDragging((prev) => !prev)}
          >
            <div className="flex items-center gap-1">
              <TbArrowsSort />
              {isDragging ? "Save" : "Edit"} Position Banner
            </div>
          </button>
          <button
            className="border rounded-lg px-3 py-2 m-1 bg-sky-700 text-white"
            onClick={() => {
              navigate(`/banner/new`);
            }}
          >
            <div className="flex items-center gap-1">
              <FaEdit />
              Create New Banner
            </div>
          </button>
        </div>
      </div>
      <h4 className="flex p-10">Published</h4>
      <div className="flex justify-center p-3">
        {banners.length > 0 ? (
          <DNDList
            list={banners}
            isDragging={isDragging}
            setRemoveId={setRemoveId}
            updateBannerOrder={updateBannerOrder}
          />
        ) : (
          <DNDList
            list={[]}
            isDragging={isDragging}
            setRemoveId={setRemoveId}
            updateBannerOrder={updateBannerOrder}
          />
        )}
      </div>
      <ModalConfirm
        show={showConfirmRemove}
        onHide={() => {}}
        cancelText={"ยกเลิก"}
        cancelAction={() => setShowConfirmRemove(false)}
        okText={"ตกลง"}
        loading={isLoading}
        okAction={() => {
          setIsLoading(true);
          deleteBanner(removeId);
        }}
        okClass="justify-center px-7 py-2 text-md font-medium text-white border border-red-700 rounded bg-red-600 hover:bg-red-700"
        maxWidth="max-w-md"
      >
        <>
          <div className="flex flex-col items-center justify-center mb-2 space-y-2 text-center">
            <FaTimesCircle className="m-3 text-red-600" size={36} />
            <h4>ต้องการลบ Banner?</h4>
            <h6>กด "ตกลง" เพื่อทำการลบ Banner</h6>
          </div>
        </>
      </ModalConfirm>
    </div>
  );
}

export default Banners;
